export enum TypUpozorneni {
	USPECH,
	INFORMACE,
	VAROVANI,
	CHYBA
}
